import React, {Component} from "react"
import defaultUserImage from '../layouts/CoreLayout/img/user_logo.jpg'
import moment from 'moment'

class UserImage extends Component {
  render() {

    const profileImagePath = this.props.path
    const size = this.props.size || 'lg'

    return (
      <img src={profileImagePath ? profileImagePath + '?' + moment().milliseconds() : defaultUserImage}
           className={`img-circle img-${size} circle-border-gray ${this.props.className || ``}`}/>
    )
  }
}

export default UserImage



// WEBPACK FOOTER //
// ./src/components/UserImage.js